import { IFormatter } from '../FormatterTypes';
import { TEDValidateDefault } from '../Validators/TEDValidateDefault';
import { TEDParseOrgNrPersNr } from '../Parsers/TEDParseOrgNrPersNr';
import { TEDDisplayOrgNrPersNr } from '../Displayers/TEDDisplayOrgNrPersNr';

class TEDFormatOrgNrPersNr implements IFormatter {
  displayer = TEDDisplayOrgNrPersNr.getInstance();
  parser = TEDParseOrgNrPersNr.getInstance();
  validator = TEDValidateDefault.getInstance();
}

export { TEDFormatOrgNrPersNr };
